export default __webpack_public_path__ + "static/media/redux.2c078a91.svg";